<div mat-dialog-title class="modal-header">
    <div class="header">
        <h2>{{ luminaria.identificacion }}</h2>
        <span class="fecha">
            {{ luminaria.dispositivo?.ultimoReporte?.fecha | date: 'short' }}
        </span>
    </div>
    <button class="config"
        [routerLink]="luminariasService.esDispositivoHoratech(luminaria) ? ['/main/luminarias/configuracion-horatech', luminaria._id] : ['/main/luminarias/configuracion', luminaria._id]"
        (click)="cerrar()">
        <mat-icon>settings</mat-icon>
    </button>
    <button mat-icon-button [ngClass]="'cerrar'" (click)="cerrar()">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-progress-bar mode="indeterminate" color="warn" [style.display]="showSpinner ? 'block' : 'none'"></mat-progress-bar>

<mat-dialog-content
    style="max-height: 80vh;display: flex;align-items: center;justify-content: center;flex-direction: column;gap: 15px;">

    <div class="mb-2 mt-2 detalles-container">
        <div class="container-detalles mb-2">
            <div class="img-container">
                <!-- Botón de detalles -->
                <button mat-icon-button class="detalles-button" matTooltip="Ver detalles completos"
                    [routerLink]="['/main/luminarias/listado', luminaria._id]" (click)="cerrar()">
                    <mat-icon>search</mat-icon>
                </button>

                <img class="img-lumi" [src]="luminariasService.determinarEstadoLuminaria(luminaria).icono"
                    alt="Luminaria status">
                <div matTooltip="Modo" class="label-modo label bg-primary"
                    *ngIf="luminariasService.determinarModoLuminaria(luminaria)">
                    <span>{{luminariasService.determinarModoLuminaria(luminaria)}}</span>
                    <span class="time-calendar">
                        <p *ngIf="luminariasService.determinarModoLuminaria(luminaria) === 'Calendario'">
                            <!-- {{ luminariasService.getHoraApagado(luminaria) | date:'shortTime' }} -->
                            -
                        </p>
                        <p *ngIf="luminariasService.determinarModoLuminaria(luminaria) === 'Calendario'">
                            <!-- {{ luminariasService.getHoraEncendido(luminaria) | date:'shortTime' }} -->
                        </p>
                    </span>
                </div>
                <div matTooltip="Acciones" class="label-acc bg-primary"
                    *ngIf="luminariasService.determinarModoLuminaria(luminaria)">
                    <ng-container *ngIf="!loading; else loadingTemplate">
                        <button mat-icon-button [matMenuTriggerFor]="menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                    </ng-container>
                    <ng-template #loadingTemplate>
                        <mat-spinner diameter="25"></mat-spinner>
                    </ng-template>
                </div>
                <mat-menu #menu="matMenu">
                    <button
                        *ngIf="luminariasService.determinarEstadoLuminaria(luminaria).ultimoEstado === 'Indeterminado' || luminariasService.determinarEstadoLuminaria(luminaria).ultimoEstado === 'Apagado' || luminariasService.determinarEstadoLuminaria(luminaria).ultimoEstado === 'Apagado Error'"
                        mat-menu-item (click)="encenderLuminaria()">Encender</button>
                    <button
                        *ngIf="luminariasService.determinarEstadoLuminaria(luminaria).ultimoEstado === 'Indeterminado' || luminariasService.determinarEstadoLuminaria(luminaria).ultimoEstado === 'Encendido' || luminariasService.determinarEstadoLuminaria(luminaria).ultimoEstado === 'Encendido Error'"
                        mat-menu-item (click)="apagarLuminaria()">Apagar</button>
                    <button
                        *ngIf="luminariasService.determinarEstadoLuminaria(luminaria).ultimoEstado === 'Encendido' || luminariasService.determinarEstadoLuminaria(luminaria).ultimoEstado === 'Encendido Error'"
                        mat-menu-item (click)="cambiarDimmer()">Potencia</button>
                </mat-menu>
                <!-- Estado -->
                <p [matTooltip]="luminariasService.determinarEstadoLuminaria(luminaria).alimentacion || ''"
                    *ngIf="luminariasService.determinarEstadoLuminaria(luminaria).ultimoEstado === 'Encendido Error'">
                    <span class="label encendida-err">
                        Encendido con Error
                    </span>
                </p>
                <p [matTooltip]="luminariasService.determinarEstadoLuminaria(luminaria).alimentacion || ''"
                    *ngIf="luminariasService.determinarEstadoLuminaria(luminaria).ultimoEstado === 'Encendido'">
                    <span class="label encendida">
                        Encendido
                    </span>
                </p>
                <p [matTooltip]="luminariasService.determinarEstadoLuminaria(luminaria).alimentacion || ''"
                    *ngIf="luminariasService.determinarEstadoLuminaria(luminaria).ultimoEstado === 'Indeterminado'">
                    <span class="label indeterminado">Indeterminado</span>
                </p>
                <p [matTooltip]="luminariasService.determinarEstadoLuminaria(luminaria).alimentacion || ''"
                    *ngIf="luminariasService.determinarEstadoLuminaria(luminaria).ultimoEstado === 'Apagado Error'">
                    <span class="label apagada-err">Apagado con Error</span>
                </p>
                <p [matTooltip]="luminariasService.determinarEstadoLuminaria(luminaria).alimentacion || ''"
                    *ngIf="luminariasService.determinarEstadoLuminaria(luminaria).ultimoEstado === 'Apagado'">
                    <span class="label apagada">Apagado</span>
                </p>
            </div>
            <div class="details">
                <mat-card class="mb-2">
                    <div class="card-content">
                        <div class="icon-detail-container" matTooltip="Deveui">
                            <mat-icon class="icon-detail">sell</mat-icon>
                            <p> {{ luminaria.deveui }} </p>
                        </div>
                        <div class="icon-detail-container" matTooltip="Ultimo Estado">
                            <mat-icon class="icon-detail">electric_bolt</mat-icon>
                            <p>
                                {{ luminariasService.determinarEstadoLuminaria(luminaria).alimentacion || '-' }}
                            </p>
                        </div>
                        <!-- <div class="icon-detail-container" matTooltip="Red">
                            <mat-icon class="icon-detail">online_prediction</mat-icon>
                            <p> (SNR: {{luminaria.dispositivo?.snr | number: '1.2-2' }} - RSSI:
                                {{luminaria.dispositivo?.rssi}})
                            </p>
                        </div> -->
                        <div class="icon-detail-container" matTooltip="Dirección">
                            <mat-icon class="icon-detail">my_location</mat-icon>
                            <p> {{ direccionLuminaria }} </p>
                        </div>
                        <div class="icon-detail-container" matTooltip="Grupo/s">
                            <mat-icon class="icon-detail">groups</mat-icon>
                            <p> {{ luminaria.establecimiento ? luminaria.establecimiento.nombre : '-' }} </p>
                        </div>
                        <div class="icon-detail-container" matTooltip="Tipo de Luminaria">
                            <mat-icon class="icon-detail">batch_prediction</mat-icon>
                            <p> {{ luminaria.modelo ? luminaria.modelo : 'Sin Modelo'}} - {{luminaria.marca ?
                                luminaria.marca : 'Sin Marca'}} </p>
                        </div>
                        <div class="icon-detail-container" matTooltip="Max. Consumo (W)">
                            <mat-icon class="icon-detail">network_check</mat-icon>
                            <p> {{ luminariasService.getConsumoMaximo(luminaria) }} </p>
                        </div>
                    </div>
                </mat-card>
            </div>
            <div class="details-map">
                <app-mapa-facil *ngIf="tieneUbicacionReal" [mapTypeId]="mapTypeId" [mapTypeControl]="mapTypeControl"
                    [iconMarker]="iconoMapa" class="map" [mapHeight]="'200px'" [coordenada]="ubicacionLuminaria" />

                <div *ngIf="!tieneUbicacionReal" class="sin-ubicacion-container">
                    <div class="sin-ubicacion-content">
                        <mat-icon>location_off</mat-icon>
                        <span>Sin ubicación</span>
                    </div>
                </div>
            </div>

        </div>
    </div>

</mat-dialog-content>